/**
 * Habit nutrition food table module.
 */

import { defineTableModule } from "../table-module";
import * as mutators from "./mutators";
import { habitNutritionFood } from "./table";

export const habitNutritionFoodModule = defineTableModule({
  name: "habit_nutrition_food",
  table: habitNutritionFood,
  mutators,
});
